import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/organization-by-producer';

export const getOrganizationsByProducers =
	(): Promise<ApiResponse> => {
		return apiClient.get(
			'/organizations/entity_type/producer'
		);
	};

export const useOrganizationsByProducers = () => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['organizations-by-producers'],
		queryFn: () => getOrganizationsByProducers(),
	});

	return {
		data: data ? data?.ids : [],
		isLoading: isFetching && !isFetched,
		isFetched,
	};
};
